import { PAYOUTS_PAYOUTS_SETUP_PATH } from 'common/selectors/sidebar/affiliates';
import reportWebVitals from 'common/helpers/reportWebVitals';
import { addSidebarDangerAction } from 'common/reducers/sidebar';
import { configFetchSuccessAction } from 'common/actions/config';

const middleware = (store) => (next) => (action) => {
  const { dispatch, getState } = store;

  const result = next(action);

  switch (action.type) {
    case configFetchSuccessAction.type: {
      const { config } = getState() || {};

      if (config.sidebarWarning.paymentDetails) {
        dispatch(addSidebarDangerAction({ path: PAYOUTS_PAYOUTS_SETUP_PATH }));
      }
      if (config.url.webVitalUrl) {
        reportWebVitals(config.url.webVitalUrl);
      }

      break;
    }

    default:
      break;
  }

  return result;
};

export default middleware;
